import React from 'react';
import classnames from 'classnames';
import s from './Badge.scss';
const Badge = ({ badge, size = 24, type = 'normal', className })=>{
    var _assets, _assets_compositeKey_map, _this, _assets1, _images_filter_map, _this1, _images_filter, _this2;
    const { title: badgeTitle, description, stackCount, assets } = badge;
    let title = badgeTitle;
    if (description) {
        title += `: ${description}`;
    }
    if (stackCount) {
        title += ` (${stackCount})`;
    }
    const compositeKey = type === 'normal' ? 'normalComposite' : 'hugeComposite';
    const images = ((_assets = assets) === null || _assets === void 0 ? void 0 : _assets[compositeKey]) ? (_this = assets[compositeKey]) === null || _this === void 0 ? void 0 : (_assets_compositeKey_map = _this.map) === null || _assets_compositeKey_map === void 0 ? void 0 : _assets_compositeKey_map.call(_this, (i)=>i.imageUrl) : [
        (_assets1 = assets) === null || _assets1 === void 0 ? void 0 : _assets1[type]
    ];
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[`size-${size}`], className),
        title: title
    }, (_this2 = images) === null || _this2 === void 0 ? void 0 : (_images_filter_map = (_this1 = (_images_filter = _this2.filter) === null || _images_filter === void 0 ? void 0 : _images_filter.call(_this2, (i)=>i)).map) === null || _images_filter_map === void 0 ? void 0 : _images_filter_map.call(_this1, (image)=>/*#__PURE__*/ React.createElement("img", {
            key: image,
            src: image,
            className: s['image'],
            alt: title,
            loading: "lazy"
        })));
};
Badge.displayName = 'Badge';
export default Badge;
